<template>
  <div>
    <div class="bg-book-demo h-100 p-3">
      <div class="box-thankyou h-100 row">
        <div
          class="col-12 col-md-5 d-flex justify-content-center align-items-center relative-left"
        >
          <div>
            <h1 class="fw-bolder" style="color: #265054">
              Thank you for your submission.
              <!-- <span class="fw-normal">your request!</span> -->
            </h1>
            <p style="font-size: 1em; color:#265054;">
              Our specialized team will be in touch with you shortly.<br />
              </p>
              <small>
                Notice: the call will be automatically recorded for quality assurance purposes. <br>
                You may opt out by mentioning "no recording" at the beginning of the call.
              </small>
          </div>
        </div>
        <div
          class="col-12 col-md-7 p-0 d-flex justify-content-end align-items-end"
        >
          <img
            src="@/assets/thankyou.png"
            style="max-height: 100%; max-width: 100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
.bg-book-demo {
  background-image: url("../assets/bg-book-demo.png");
  background-size: cover;
  background-repeat: no-repeat;
  max-width: 100%;
  min-height: 100vh;
  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.box-thankyou {
  box-shadow: 0px 4px 24px 0px #0000001a;
  background: white;
  min-height: 90vh;

  border-radius: 8px;
  @media (min-width: 768px) {
    width: 100%;
    max-width: 100%;
  }
  @media (max-width: 767.89px) {
    margin: 3px;
  }
}

.relative-left {
  @media (min-width: 768px) {
    position: relative;
    left: 50px;
  }
}
</style>
